import Vue from "vue";
import Router from "vue-router";
// import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { layout: "blue-background" },
      component: () => import("@/modules/weather/Index.vue"),
    },
    {
      path: "/weatherChannel",
      name: "weatherChannel",
      component: () => import("@/views/About.vue"),
    },
  ],
});
